import { IConfigurationService, IChatModsConfiguration } from '@/app-modules/config';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

function getGameConfiguration(): IChatModsConfiguration {
  const configurationService: IConfigurationService = container.get(SERVICE_IDENTIFIERS.IConfigurationService);
  return configurationService.getConfigurationSync();
}

export { getGameConfiguration };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/helpers/game-config-helper.ts